export const sectionName = 'root-ui';
